import React, { useContext } from "react";
import NoticesTable from "./NoticesTable";
import { Button, Space } from "antd";
import { context } from "../../context/context";

const Notices = () => {
    const { setIsNoticeModalOpen, setDataInput, setTitleInput, setFileList, setCoverPic } =
        useContext(context);
    const handleClick = () => {
        setIsNoticeModalOpen(true);
        setDataInput("");
        setTitleInput("");
        setFileList([]);
        setCoverPic()
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <Button onClick={handleClick} type="primary">
                    ساخت اعلان جدید
                </Button>
            </Space>
            <NoticesTable />
        </>
    );
};

export default Notices;
